import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SERVER_BASE_URL } from '../environment.token';

@Component({
  selector: 'ca-image-block',
  imports: [CommonModule],
  template: `
@if (data) {
  <figure>
    <img [src]="data && data.src ? base + data.src : undefined" [alt]="data.alt" />
    @if (data.caption){
    <figcaption>{{data.caption}}</figcaption>
    }
  </figure>
}
`,
})
export class ImageBlockComponent {
  @Input() data?: ImageBlockData;
  readonly base = inject(SERVER_BASE_URL);
}

export interface ImageBlockData {
  src: string;
  alt: string;
  caption?: string;
}
